export default __webpack_public_path__ + "static/media/logo.0aa0ed41.png";